
import Components from "slotworks/components/components";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";

export function SkipSpinCommand(spinRecord: SpinRecord) {
    return Components.matrix.skipTransition(spinRecord);
}
